import { createEvent, createStore } from 'effector'

export const actions = {
  setForm: createEvent<Partial<IncidentForm>>('setIncidentForm'),
  resetForm: createEvent('resetIncidentForm'),
  addForm: createEvent<Partial<IncidentForm>>('addIncidentForm'),
  removeForm: createEvent<string>('removeIncidentForm'),
  setForms: createEvent<Partial<IncidentForm>[]>('setIncidentForms'),
  resetForms: createEvent('resetIncidentForms'),
  addIncident: createEvent<IncidentResponse>('addIncident'),
  setIncidents: createEvent<IncidentResponse[]>('setIncidents'),
  resetIncidents: createEvent('resetIncidents'),
  reset: createEvent('reset'),
  partialReset: createEvent<keyof IncidentForm>('partialReset'),
}

export const initialState: IncidentState = {
  form: {} as IncidentForm,
  forms: [],
  incidents: [],
}

export const store = createStore<IncidentState>(initialState, { name: 'incident' })
  .on(actions.setForm, (s, part) => ({ ...s, form: { ...s.form, ...part } }))
  .on(actions.resetForm, (s) => ({ ...s, form: initialState.form }))
  .on(actions.addForm, (s, form) => ({ ...s, forms: [...s.forms, form] }))
  .on(actions.removeForm, (s, id) => ({ ...s, forms: s.forms.filter((f) => f.id !== id) }))
  .on(actions.setForms, (s, forms) => ({ ...s, forms }))
  .on(actions.resetForms, (s) => ({ ...s, forms: initialState.forms }))
  .on(actions.addIncident, (s, incident) => ({ ...s, incidents: [...s.incidents, incident] }))
  .on(actions.setIncidents, (s, incidents) => ({ ...s, incidents }))
  .on(actions.resetIncidents, (s) => ({ ...s, incidents: initialState.incidents }))
  .on(actions.partialReset, (s, key) => ({ ...s, form: { ...s.form, [key]: initialState.form[key] } }))
  .reset(actions.reset)
